// material
import {
     Button,
     Dialog,
     DialogTitle,
     DialogActions,
     DialogContent,
     MenuItem,
     FormControl,
     Grid,
     Divider,
     TextField
} from '@mui/material';
import { useTranslation } from 'react-i18next';


// ----------------------------------------------------------------------

export default function ModalFunilChat({
  closeModalFunilChat,
  valorEscolhidoFunilProps,
  handleFunil,
  listaFunilProps,
  stateModalFunilProps,
  submitFunilChat
}) {
  const { t } = useTranslation('chat');

  return (
    <div>

      <Dialog 
      open={stateModalFunilProps}
      fullWidth={true}
      maxWidth={'sm'}
      >
        <DialogTitle>{t('funil.salesFunnel')}</DialogTitle>
        <DialogContent>
    
              <Grid container spacing={2}>
                     <Grid item md={6}>
                          <FormControl  fullWidth sx={{ m: 1, minWidth: 120 }}>
                          <TextField
                            select
                            fullWidth
                            //label="Select"
                            value={valorEscolhidoFunilProps}
                            onChange={event => handleFunil(event)}
                          
                          >
                        {listaFunilProps.map((option) => (
                          <MenuItem key={option._id} value={option._id}>
                            {option.nome_funil}
                          </MenuItem>
                        ))}
                        </TextField>
                          </FormControl>
                        </Grid>
              
              
            </Grid>
       
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button onClick={closeModalFunilChat}>{t('common:buttons.cancel')}</Button>
          <Button variant="contained" onClick={submitFunilChat} autoFocus>{t('common:buttons.save')}</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
